import { Injectable, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { ToastrService } from "ngx-toastr";
import { HeaderService } from './header.service';



@Injectable({ providedIn: 'root' })
export class AuthService  implements OnInit{
  private isAuthenticated: boolean = false;

  
  constructor(private http: HttpClient, private toastr: ToastrService, private headerService: HeaderService) {
    const tokens = this.getAuthorizationToken()?.authorization;
    if (tokens) {
      this.isAuthenticated = true;
    }
  }
  ngOnInit(): void {
      
  }

  login(email: string, password: string): Observable<boolean> {

    const loginData = { email, password }; // Create login data object with email and password only
    const apiUrl = `${environment.baseUrl}auth/login`; // Construct API URL with base URL
    return this.http.post<any>(apiUrl, loginData) // Make a POST request with login data
      .pipe(
        map((response) => {
        if(response?.success === false){
          this.toastr.error(response.errorResponse.errorDescription);
        }
          this.isAuthenticated = true;
          const tokens = {
            //authorization: response.member.accessToken,
            authorization: response.member.idToken,
            refresh_token: response.member.refreshToken,
          };
          localStorage.setItem('tokens', JSON.stringify(tokens));
          this.headerService.setAuthentication(true).subscribe();
          return true;
        }),
        catchError((error) => {
          console.error('Login error:', error); // Log detailed error information
          if (error.error) { // Check if there's an error object with a message
            return throwError(new Error(error.error.message || 'Network error')); // Provide a more specific error message
          } else {
            return throwError(new Error('Network error')); // Handle other errors
          }
        })
      );
  
  }

  loginWithIdToken(idToken: string, accessToken: string, refreshToken?: string) {
    return this.http.post<any>(`${environment.baseUrl}auth/sso`, {
      idToken,
      accessToken,
      refreshToken
    });
  }

  refreshToken(): Observable<boolean> {
    const refreshToken = this.getAuthorizationToken()?.refresh_token;
    if (!refreshToken) {
      return throwError(new Error('Refresh token not found'));
    }
    const apiUrl = `${environment.baseUrl}auth/refreshtoken`; // Assuming API endpoint for refreshing token
    return this.http.post<any>(apiUrl, { refresh_token: refreshToken }).pipe(
      map((response) => {
        const tokens = this.getAuthorizationToken();
        if (tokens) {
          tokens.authorization = response.member.idToken;
          localStorage.setItem('tokens', JSON.stringify(tokens));
        }
        return true;
      }),
      catchError((error) => {
        console.error('Refresh token error:', error);
        return throwError(error);
      })
    );
  }

  isAuthenticatedUser(): boolean {
    return this.isAuthenticated;
  }

  updateAuthenticationStatus(status: boolean): void {
    this.headerService.setAuthentication(status).subscribe(); // Subscribe to setAuthentication
  }

  getAuthorizationToken(): { authorization: string, refresh_token: string } | null {
    if (typeof window !== 'undefined' && window.localStorage) {
      const storedTokens = localStorage.getItem('tokens');
      if (storedTokens) {
        try {
          return JSON.parse(storedTokens);
        } catch (error) {
          console.error('Error parsing stored tokens:', error);
          return null; // Handle potential parsing errors
        }
      } else {
        return null; // No tokens stored
      }
    } else {
      return null; // Local storage not available
    }
  }


  
  logout(): void {
    localStorage.removeItem('tokens');
    localStorage.removeItem('user');
    localStorage.removeItem('authStatus');
    localStorage.removeItem('selectedCountry');
    this.isAuthenticated = false;
  }
}
